import React from 'react'

import {usePaymentCardAdd} from './PaymentCardAdd.hooks'
import type {Props} from './PaymentCardAdd.types'
import {PaymentCardAddButton} from './PaymentCardAddButton'
import {TrustModal} from './TrustModal'

export function PaymentCardAdd(props: Props): React.ReactElement<Props> {
  const {fetchCardBoundContext} = props
  const {opened, openHandler, successHandler, closeHandler} = usePaymentCardAdd(props)

  return (
    <>
      <PaymentCardAddButton onPress={openHandler} />
      {opened && <TrustModal fetchCardBoundContext={fetchCardBoundContext} onClose={closeHandler} onSuccess={successHandler} />}
    </>
  )
}
